module.exports = __webpack_public_path__ + "static/media/34DSS9.fda0f99b.jpg";